import React from 'react';

const emptyResults = () => (
  <h4 className="font-weight-bold">No job postings found matching this search.</h4>
);

export default emptyResults;
